import { InvitesState } from "@share/invites/store/InvitesState";

export const state: InvitesState = {
    dataHelper: null,
    intervalId: 0,
    invitesNotAnsweredCount: null,
    repositories: null,
    eventId: '',
    useRealtimeUpdates: true,
    realTimeCbMeeting: null,
    realTimeCbInvite: null
}